import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const ConfirmGuestFormValidationSchema = yup.object({
    password: RHFUserValidationRules.password
});

export type ConfirmGuestFormValues = yup.InferType<
    typeof ConfirmGuestFormValidationSchema
>;
